// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"260":"ae51ba48","678":"component---src-pages-index-js","874":"1a48c3c1","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"260":"911b86db724c05197de9","678":"a78836c8d9a6748c886e","874":"1bbcaca973633c345d34","883":"759cf3d3fe6e64e57918","954":"ac0610a8e2e8bd3e5bc9"}[chunkId] + ".js";
};